function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 335.735,
    cy: 226.155,
    r: 291.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    style: {
      stopColor: "#3d51b0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 400.871,
    cy: 289.033,
    r: 155.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56a3e2",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    style: {
      stopColor: "#4b7ecb",
      stopOpacity: 0.2002
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    style: {
      stopColor: "#405ab6",
      stopOpacity: 0.4324
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#3840a6",
      stopOpacity: 0.6502
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    style: {
      stopColor: "#33309c",
      stopOpacity: 0.8457
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 375.918,
    cy: 265.64,
    r: 184.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 466.911,
    cy: 280.858,
    r: 130.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 432.149,
    cy: 303.569,
    r: 188.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 481.493,
    cy: 258.677,
    r: 158.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 351.711,
    cy: 261.516,
    r: 163.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 638.538,
    cy: 312.327,
    r: 408.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 496.949,
    cy: 276.459,
    r: 251.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#56a3e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#4b7ecb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#405ab6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#3840a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#33309c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    style: {
      stopColor: "#312b99"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M486.988 276.575h-35.194l-17.004 24.209-17.004-24.209h-35.194l-19.131 34.045 13.985 43.893 57.344 43.499 57.344-43.499 13.985-43.893z",
    style: {
      fill: "url(#a)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.45 297.548h-28.089l-13.571 17.217-13.571-17.217H393.13l-15.269 24.211 11.162 31.216 45.767 30.934 45.767-30.934 11.162-31.216z",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.861 321.759-14.4-11.139 19.131-34.045 10.538 20.973z",
    style: {
      fill: "url(#c)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.719 321.759 14.4-11.139-13.985 43.893-11.577-1.538z",
    style: {
      fill: "url(#d)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.719 321.759-11.162 31.216-45.767 30.934 41.66-86.361z",
    style: {
      fill: "url(#e)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.794 276.575-3.433 20.973-13.571 17.217v-13.981z",
    style: {
      fill: "url(#f)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79 300.784v13.981l-13.571-17.217-3.433-20.973z",
    style: {
      fill: "url(#g)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.057 356.797-45.767 30.935-30.057-20.316 83.122-31.027z",
    style: {
      fill: "url(#h)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.13 297.548-15.269 24.211 7.433 20.787 35.925-44.998z",
    style: {
      fill: "url(#i)"
    },
    transform: "translate(-89.733 -65.115)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorazon);
export default __webpack_public_path__ + "static/media/corazon.fe64c692d7c834b0be394af0c01d1897.svg";
export { ForwardRef as ReactComponent };